import { AbstractControl } from "@angular/forms";

export function startDateValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!control.parent) return null;

  const startDate = control.value;
  const endDateControl = control.parent.get('endDate');
  const endDate = endDateControl?.value;

  // Validar que la fecha de inicio sea al menos 15 minutos desde la fecha actual
  if (startDate) {
    const minimumDate = new Date();
    minimumDate.setMinutes(minimumDate.getMinutes() + 15);
    minimumDate.setSeconds(0, 0);
    const startDateObj = new Date(startDate);

    if (startDateObj < minimumDate) {
      return { startDateTooSoon: true };
    }
  }

  // Validar que la fecha de inicio sea menor que la fecha de fin
  if (startDate && endDate && startDate >= endDate) {
    return { startDateAfterEndDate: true };
  }

  return null;
}

export function endDateValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!control.parent) return null;

  const endDate = control.value;
  const startDateControl = control.parent.get('startDate');
  const startDate = startDateControl?.value;

  // Validar que la fecha de fin sea mayor que la fecha de inicio
  if (endDate && startDate && endDate <= startDate) {
    return { endDateBeforeStartDate: true };
  }

  // Validar que la fecha de fin no vaya más allá del domingo de la semana de inicio a las 23:59
  if (startDate && endDate) {
    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);
    
    // Encontrar el domingo de la semana de la fecha de inicio
    const dayOfWeek = startDateObj.getDay(); // 0 = domingo, 1 = lunes, etc.
    const daysUntilSunday = 7 - dayOfWeek;
    const sundayOfWeek = new Date(startDateObj);
    sundayOfWeek.setDate(startDateObj.getDate() + daysUntilSunday);
    sundayOfWeek.setHours(23, 59, 59, 999);

    if (endDateObj > sundayOfWeek) {
      return { endDateBeyondWeekEnd: true };
    }
  }

  return null;
}

export function urlValidator(control: AbstractControl): { [key: string]: any } | null {
  const value = control.value;
  
  if (!value) return null;
  
  // Patrón más flexible para URLs de plataformas como Google Meet, Discord, Zoom, etc.
  const urlPattern = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.(?:[a-zA-Z0-9()]{1,6}|[a-zA-Z0-9()]{1,6}\/[a-zA-Z0-9()]{1,6})\b(?:[-a-zA-Z0-9()@:%_\+.~#?&=\/]*)$/;
  
  // Validaciones específicas para plataformas conocidas
  const googleMeetPattern = /^https:\/\/meet\.google\.com\/[a-z0-9\-]+(\?.*)?$/;
  const discordPattern = /^https:\/\/discord\.(?:gg|com)\/[a-zA-Z0-9\-_\/]+(\?.*)?$/;
  
  // Verificar si es una URL válida o coincide con algún patrón específico
  if (!urlPattern.test(value) && 
      !googleMeetPattern.test(value) && 
      !discordPattern.test(value)) {
    return { invalidUrl: true };
  }
  
  return null;
}
